import React from "react"

function Header(props) {
  return (
    <div className="my-3">
      <h1 className="text-center head tran_color">{props.title}</h1>
    </div>
  )
}

export default Header
